<script lang="ts">
    import { theme, toggleTheme } from '$lib/stores/theme';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    import Moon from '@lucide/svelte/icons/moon';
    import Sun from '@lucide/svelte/icons/sun';

    const { showLabel = false } = $props<{ showLabel?: boolean }>();

    let mounted = $state(false);

    onMount(() => {
        mounted = true;
    });
</script>

{#if mounted}
<button
    onclick={toggleTheme}
    type="button"
    class="inline-flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 transition-colors"
    aria-label="Toggle theme"
>
    {#if $theme === 'dark'}
        <Sun class="h-5 w-5 text-yellow-500" />
        {#if showLabel}
            <span>{$_('settings.switchToLight')}</span>
        {/if}
    {:else}
        <Moon class="h-5 w-5 text-gray-700 dark:text-gray-200" />
        {#if showLabel}
            <span>{$_('settings.switchToDark')}</span>
        {/if}
    {/if}
</button>
{/if}
